import { newRidgeState } from 'react-ridge-state';
import { ManagerDto } from '@generated/admin';
import { ModalInfoProps } from '../components/modal/Modal';
import { User } from '../types';
import { api, managerApi } from './axios';

/**
 * GET /manager/me 응답을 그대로 쓴다.
 *
 * 손으로 한 벌 더 적어두면 서버가 필드를 줄여도 화면 타입은 그대로라
 * 컴파일이 통과한다 — 실제로 무엇이 오는지 알 수 없어진다.
 */
export type ManagerInfo = ManagerDto;

export const managerMeState = newRidgeState<ManagerInfo | null>(null);
export const managerTokenState = newRidgeState<string | null>(null, {
  onSet: async (newState) => {
    if (newState) {
      localStorage.setItem('manager_token', newState);
      const result = await managerApi.get('/manager/me').catch((e) => {
        console.log('managerTokenState error : ', e);
        managerTokenState.set(null);
      });
      if (result && (result.status === 200 || result.status === 201)) {
        managerMeState.set(result.data);
      }
    } else {
      managerMeState.reset();
      localStorage.removeItem('manager_token');
    }
  },
});

export const meState = newRidgeState<User | null>(null);
export const tokenState = newRidgeState<string | null>(null, {
  onSet: async (newState) => {
    if (newState) {
      localStorage.setItem('token', newState);
      const result = await api.get('/users/me').catch((e) => {
        console.log('tokenState error : ', e);
        localStorage.removeItem('token');
      });
      if (result && (result.status === 200 || result.status === 201)) {
        meState.set(result.data);
      }
    } else {
      meState.reset();
      localStorage.removeItem('token');
    }
  },
});

export const osState = newRidgeState<string>('');

function setInitialState() {
  const token = localStorage.getItem('token');
  tokenState.set(token);
  const managerToken = localStorage.getItem('manager_token');
  if (managerToken) {
    managerTokenState.set(managerToken);
  }
}

export const modalState = newRidgeState<ModalInfoProps>({
  title: '',
  bodyText: '',
  primaryClick: () => {},
  primaryButtonText: '',
  primaryButtonClassName: '',
  secondaryClick: () => {},
  secondaryButtonText: '',
  secondaryButtonClassName: '',
});

setInitialState();
